<template>
	<div class="cta">
		<a class="cta-button" target="_blank" href="https://www.manhattanstreetcapital.com/offering/30417/invest/amount?invest/?utm_source=srax&utm_medium=display&utm_campaign=geosolar&utm_content=20210713">{{ ctaText }}</a>
	</div>
</template>
<script>
export default {
	name: 'CTA',
	props: {
		ctaText: {
			type: String,
			default: 'INVEST in GeoSolar Technologies NOW',
			required: false
		},
		showOffering: {
			type: Boolean,
			default: true,
			required: false
		}
	},
	data() {
		return {
		}
	}
}
</script>
<style lang="scss" scoped>
@import "../styles/components/cta.scss";
</style>
